import { EndpointBuilder } from '@reduxjs/toolkit/query';
import {
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta
} from '@reduxjs/toolkit/query';
import { BaseQueryFn } from '@reduxjs/toolkit/query';
import { AllFeaturePanelRecord, CreateFeaturePanelRecord, FeatureOtionData } from '../../types/records/featureAccessPanel';

export const featureConfigEndPoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      NonNullable<unknown>,
      FetchBaseQueryMeta
    >,
    string,
    'prepaidEngineApi'
  >
) => ({
  getAllFeatures: builder.query<AllFeaturePanelRecord[], void>({
    query: () => ({
      url: `/prepaid-engine/feature_access_control/`
    }),
    providesTags: ['getAllFeatures']
  }),
  createFeatureAccess: builder.mutation<'', {data:Partial<CreateFeaturePanelRecord>[]}>({
        query: (data) => ({
          url: `/prepaid-engine/feature_access_control/many`,
          method: 'POST',
          body: data
        }),
        invalidatesTags: ['getAllFeatures']
      }),
  featureDropdownOptions: builder.query<FeatureOtionData, void>({
    query: () => ({
      url: `/prepaid-engine/mdms_api/feature_access_control/dropdowns`
    }),
    providesTags: ['']
  }),
});
